import i18n from '@/plugins/i18n.js';

export const validator = {
  data: () => {
    return {
      rules: {
        required: (
          value,
          errorMessage = i18n.t('validationMessages.required'),
        ) => !!value || errorMessage,
        password: value =>
          value.length >= 6 || i18n.t('validationMessages.password'),
        phoneVerify: value =>
          value.length >= 4 || i18n.t('youMustEnterFourDigitsOfCode'),
        stringLength: (value, length) => {
          if (value.length == length) {
            return true;
          } else {
            return i18n.t('thisFieldMustHave') + length + i18n.t('characters');
          }
        },
        expirationDate: (
          value,
          dateOfIssueField,
          me,
          errorMessage = i18n.t('validationMessages.expiration'),
        ) => {
          if (value != '' && me.form[dateOfIssueField].value != '') {
            let dateOfIssue = new Date(
              me.form[dateOfIssueField].value,
            ).getTime();
            let expirationDate = new Date(value).getTime();
            if (dateOfIssue < expirationDate) {
              return true;
            } else {
              return errorMessage;
            }
          } else {
            return true;
          }
        },
        dateOfIssue: (
          value,
          errorMessage = i18n.t('validationMessages.issue'),
        ) => {
          if (value != '') {
            let today = new Date().getTime();
            let dateOfIssue = new Date(value).getTime();
            if (dateOfIssue <= today) {
              return true;
            } else {
              return errorMessage;
            }
          } else {
            return true;
          }
        },
        email: value =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            value,
          ) || i18n.t('validationMessages.email'),
        rut: value => {
          let nAcumula = 0;
          let nFactor = 2;
          let nDv = 0;
          let nDvReal = null;
          let rut = value.replace(/[. ,-]+/g, '');
          if (rut.charAt(rut.length - 1).toUpperCase() == 'K') {
            nDvReal = 10;
          } else if (rut.charAt(rut.length - 1) == 0) {
            nDvReal = 11;
          } else {
            nDvReal = rut.charAt(rut.length - 1);
            for (let nPos = rut.length - 2; nPos >= 0; nPos--) {
              nAcumula += rut.charAt(nPos).valueOf() * nFactor;
              nFactor++;
              if (nFactor > 7) nFactor = 2;
            }
          }
          nDv = 11 - (nAcumula % 11);
          if (nDv == nDvReal) {
            return true;
          }
          return i18n.t('validationMessages.rut');
        },
      },
      modifiers: {
        rut: value => {
          if (value.length > 2) {
            let rut = value.replace(/[. ,-]+/g, '');
            let sRut1 = rut;
            let nPos = 0;
            let sInvertido = '';
            let sRut = '';
            for (let i = sRut1.length - 1; i >= 0; i--) {
              sInvertido += sRut1.charAt(i);
              if (i == sRut1.length - 1) {
                sInvertido += '-';
              } else if (nPos == 3) {
                sInvertido += '.';
                nPos = 0;
              }
              nPos++;
            }
            for (let j = sInvertido.length - 1; j >= 0; j--) {
              if (sInvertido.charAt(sInvertido.length - 1) != '.') {
                sRut += sInvertido.charAt(j);
              } else if (j != sInvertido.length - 1) {
                sRut += sInvertido.charAt(j);
              }
            }
            return sRut.toUpperCase();
          } else {
            return value;
          }
        },
      },
    };
  },
  methods: {
    evaluateInput(event) {
      setTimeout(() => {
        let { name, value } = event.target;
        this.modifyInput(this.form[name].modifiers, name);
        let evaluation = this.validateInput(this.form[name].rules, value);
        evaluation !== true
          ? (this.form[name].error = evaluation)
          : (this.form[name].error = '');
      }, 0);
    },
    cleanErrors() {
      for (let item in this.form) {
        item.error = '';
      }
    },
    cleanForm() {
      for (let item in this.form) {
        item.value = '';
        item.error = '';
      }
    },
    validateForm() {
      let isValid = true;
      Object.keys(this.form).forEach(key => {
        this.modifyInput(this.form[key].modifiers, key);
        let evaluation = this.validateInput(
          this.form[key].rules,
          this.form[key].value,
        );
        evaluation !== true
          ? ((this.form[key].error = evaluation), (isValid = false))
          : (this.form[key].error = '');
      });
      return isValid;
    },
    validateInput(rules, value) {
      let evaluation = true;
      if (rules) {
        for (let rule of rules) {
          evaluation = rule(value);
          if (evaluation !== true) {
            break;
          }
        }
      }
      return evaluation;
    },
    modifyInput(modifiers, name) {
      if (modifiers) {
        for (let modifier of modifiers) {
          this.form[name].value = modifier(this.form[name].value);
        }
      }
    },
  },
};
